'use client';

import { useCallback } from 'react';
import useVelocityStore from 'src/stores/VelocityStore/useVelocityStore';

type UIElementKeys = 'recentTrades';

/**
 * Hook for managing loading state queue
 */
export const useLoadingQueue = () => {
	const setVelocityStore = useVelocityStore((s) => s.set);
	const getVelocityStore = useVelocityStore((s) => s.get);

	const addLoadingItemToQueue = useCallback(
		(props: { key: UIElementKeys }) => {
			setVelocityStore((s) => {
				s.loadingElements = {
					...s.loadingElements,
					[props.key]: {
						isLoading: true,
					},
				};
			});
		},
		[setVelocityStore]
	);

	const removeLoadingItemFromQueue = useCallback(
		(props: { key: UIElementKeys }) => {
			// Trigger callback for when item is cleared from queue
			getVelocityStore().loadingElements[props.key]?.callback?.();

			setVelocityStore((s) => {
				s.loadingElements = {
					...s.loadingElements,
					[props.key]: {
						isLoading: false,
					},
				};
			});
		},
		[setVelocityStore, getVelocityStore]
	);

	return { addLoadingItemToQueue, removeLoadingItemFromQueue };
};
